module.exports = __webpack_public_path__ + "img/PlaceholderImage.bed5aea7.svg";